<template>
  <div class="container-custom">
    <!-- BreadScrumbs -->
    <BreadScrumbs
      :links="[{ name: 'Latest Events', to: { path: '/latest-events' } }]"
    ></BreadScrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>Latest Events</h2>
      <v-spacer></v-spacer>
      <button class="btn btn-primary" @click="createHandler">
        <v-icon class="pr-2 white--text">add</v-icon>
        <span>新增Event</span>
      </button>
    </div>
    <!--  -->
    <LatestEventsTable class="mb-5"></LatestEventsTable>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import BreadScrumbs from '@/components/Breadscrumbs.vue';
import LatestEventsTable from '@/views/I-2_IR-LatestEvents/c/LatestEventsTable.vue';

export default {
  components: {
    BreadScrumbs,
    LatestEventsTable,
  },
  created() {
    this.clear();
    this.getShareholderEvents();
  },
  methods: {
    ...mapActions('shareholderEvent', {
      getShareholderEvents: 'find',
      clear: 'clear',
    }),
    createHandler() {
      this.$router.push('/latest-events/create');
    },
    toEditPageTitle() {
      this.$router.push('/latest-events/edit-latest-event-page-title');
    },
  },
};
</script>

<style></style>
